// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

export const fourK = {
  toolTipText: `
<div class="magnet-legend">
  <h3>Legend</h3>
  <ul>
    <li><strong>He</strong> = Helium volume in liter</li>
    <li><strong>He 1 and He2 (%)</strong> = Helium levels of Probe 1 and 2</li>
    <li><strong>CHT (K)</strong> = Cold Head Temperature</li>
    <li><strong>Link (K) and Bore (K)</strong> = 50k Shield Link and Bore Temperature</li>
    <li><strong>PHAP (W/4h)</strong> = Pressure Heater Average Power</li>
    <li><strong>MP (bar)</strong> = Scaled Magnet Pressure</li>
    <li><strong>MPScaled (bar)</strong> = Scaled Magnet Pressure, is (MP-13)*20+15 for better visualization</li>
    <li><strong>BV (V)</strong> = Battery Voltage</li>
    <li><strong>CSS (#/1d)</strong> = Compressor Stop Start</li>
    <li><strong>DP (hPa) and DynP (hPa)</strong> = Dynamic Pressure of Compressor</li>
    <li><strong>SP (bar)</strong> = Supply Pressure of SEP or IFP</li>
    <li><strong>RP (bar)</strong> = Return Pressure of SEP or IFP</li>
    <li><strong>CSP (bar)</strong> = Chiller Static Pressure</li>
    <li><strong>ZF #/1d)</strong> = Zero Field</li>
    <li><strong>RPM</strong> = Pump speed</li>
    <li><strong>MIX (%)</strong> = Mixer position</li>
    <li><strong>X,Y,Z (K)</strong> = Gradient Coil Connector Temperatures</li>
  </ul>
</div>`,
} as const;

export const tenK = {
  toolTipText: `
<div class="magnet-legend">
  <h3>Legend</h3>
  <ul>
    <li><strong>Helium</strong> = Helium level of the magnet</li>
    <li><strong>Shield</strong> = Shield Temperature</li>
    <li><strong>Battery</strong> = Battery Voltage</li>
    <li><strong>CSS</strong> = Compressor Stop Start</li>
    <li><strong>DynP</strong> = Dynamic Pressure</li>
    <li><strong>ZF</strong> = Zero Field</li>
    <li><strong>RP</strong> = Return Pressure</li>
    <li><strong>CSP</strong> = Chiller Static Pressure</li>
  </ul>
</div>`,
} as const;

export const DryCool = {
  toolTipText: `
<div class="magnet-legend">
  <h3>Legend</h3>
  <ul>
    <li><strong>Bore</strong> = 50K Bore Temperature (K)</li>
    <li><strong>BV</strong> = ERDU Battery Voltage (V)</li>
    <li><strong>CAT</strong> = Coil A Temperature (K)</li>
    <li><strong>CFT</strong> = Coil F Temperature (K)</li>
    <li><strong>CH1</strong> = Cold Head Temperature (1st stage K)</li>
    <li><strong>CRT</strong> = Compressor Run Time (hours)</li>
    <li><strong>HHP</strong> = Helium High Pressure (bar)</li>
    <li><strong>HLP</strong> = Helium Low Pressure (bar)</li>
    <li><strong>HPT</strong> = Helium Pot Temperature (K)</li>
    <li><strong>I-PF</strong> = IDU Primary Water Flow (Link)</li>
    <li><strong>I-PT</strong> = IDU Primary Temperature (°C)</li>
    <li><strong>I-RP</strong> = IDU Return Pressure (bar)</li>
    <li><strong>I-SP</strong> = IDU Supply Pressure (bar)</li>
    <li><strong>I-ST</strong> = IDU Water Temperature (°C)</li>
    <li><strong>Link</strong> = 50K Link Temperature (K)</li>
    <li><strong>MiP</strong> = Mixer Position (%)</li>
    <li><strong>MP</strong> = Magnet Pressure (bar)</li>
    <li><strong>PuR</strong> = Pump Revolution (rpm)</li>
    <li><strong>SWT</strong> = Switch Temperature (K)</li>
  </ul>
</div>`,
} as const;
